var DealModes;
(function (DealModes) {
    DealModes["Default"] = "MODE_DEFAULT";
    DealModes["Compact"] = "MODE_COMPACT";
    DealModes["FullPage"] = "MODE_FULL_PAGE";
})(DealModes || (DealModes = {}));
export default DealModes;
